import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { formatNumber } from "utils/formatNumber";
import { Carousel } from "react-responsive-carousel";
import TextPreview from "./components/TextPreview";
import MediaPreview from "./components/MediaPreview";
import AddAssetButton from "./components/AddAssetButton";
import CommentSection from "./components/CommentsSection"

const InstagramFeedPreview = (post) => {
    
    const {
        user_name,
        user_image,
        text,
        media,
        like_count,
        className,
        imgClassName,
        title,
        preferences,
        link,
        assets,
        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit, 
        onTitleEdit, 
        onLinkEdit, 
        onCreateNetworkPost,
        onDeleteIndexPost,
        onPreferencesEdit,
        allPosts = [],
        isSimpleView,
        onCommentsToCreateEdit,
    } = post;

    const network = "instagram";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == "instagram")?.[0];
    const [ aspectRatioCarousel, setAspectRatioCarousel ] = useState("aspect-square");
    
    const carouselRef = useRef();
    const [ assetQuantity, setAssetQuantity ] = useState(assets?.length);

    useEffect(() => {
        if (assetQuantity && carouselRef.current) {
            if (assetQuantity < assets?.length) {
                carouselRef.current?.moveTo(assets?.length - 1);
            }
            setAssetQuantity(assets?.length);
        }
    }, [assets?.length, carouselRef.current]);
    
    if (preferences?.media_product_type != "FEED" && preferences?.media_product_type != "REEL") return <></>;
    
    return (
        <div className={`instagram flex flex-col ${className}`}>
            <div className="flex items-center justify-between w-full p-4 py-3">
                <div className="flex items-center gap-3">
                    <img 
                        src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} 
                        className="rounded-full h-10 w-10 object-contain" 
                    />
                    <div className="flex flex-col">
                        <span className="!text-sm font-bold text-tertiary-700 dark:text-gray-100">{user_name || integration?.name || company?.name}</span>
                    </div>
                </div>
            </div>
            {assets?.length > 1 &&
                <Carousel 
                    key={`${assets?.length}_carousel`} 
                    showThumbs={assets?.length > 0} 
                    infiniteLoop={false} 
                    autoPlay={false} 
                    className="relative showDots showArrows"
                    ref={carouselRef}
                >
                    {assets?.map((asset, key) => (<>
                        <MediaPreview 
                            asset={asset} 
                            parentClassName="!block"
                            className={`w-full object-cover !pointer-events-auto ${aspectRatioCarousel}`}
                            network={network}
                            isEditable={isEditable && !isSimpleView} // Update this line
                            onAssetDelete={() => onAssetDelete(postIndex, key)}
                            onAssetEdit={(src) => onAssetEdit(postIndex, key, src)}
                        />
                    </>))}
                </Carousel>
            }
            {assets?.length == 1 &&
                <MediaPreview 
                    asset={assets?.[0]} 
                    parentClassName={`w-full h-auto !aspect-auto`}
                    className={`w-full h-auto`} 
                    network={network}
                    isEditable={isEditable && !isSimpleView} // Update this line
                    onAssetDelete={() => onAssetDelete(postIndex, 0)}
                    onAssetEdit={(src) => onAssetEdit(postIndex, 0, src)}
                />
            }
            {isEditable && !isSimpleView && 
                <div className="px-4 py-2">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                        allPosts={allPosts}
                    />
                </div>
            }
            <div className="flex items-center justify-between w-full p-4 py-3 pb-0">
                <div className="flex gap-5 items-center">
                    <svg aria-label="Me gusta" className="fill-tertiary-700 dark:fill-gray-300 text-tertiary-700 dark:text-gray-300" height="24" role="img" viewBox="0 0 24 24" width="24"><title>Me gusta</title><path d="M16.792 3.904A4.989 4.989 0 0 1 21.5 9.122c0 3.072-2.652 4.959-5.197 7.222-2.512 2.243-3.865 3.469-4.303 3.752-.477-.309-2.143-1.823-4.303-3.752C5.141 14.072 2.5 12.167 2.5 9.122a4.989 4.989 0 0 1 4.708-5.218 4.21 4.21 0 0 1 3.675 1.941c.84 1.175.98 1.763 1.12 1.763s.278-.588 1.11-1.766a4.17 4.17 0 0 1 3.679-1.938m0-2a6.04 6.04 0 0 0-4.797 2.127 6.052 6.052 0 0 0-4.787-2.127A6.985 6.985 0 0 0 .5 9.122c0 3.61 2.55 5.827 5.015 7.97.283.246.569.494.853.747l1.027.918a44.998 44.998 0 0 0 3.518 3.018 2 2 0 0 0 2.174 0 45.263 45.263 0 0 0 3.626-3.115l.922-.824c.293-.26.59-.519.885-.774 2.334-2.025 4.98-4.32 4.98-7.94a6.985 6.985 0 0 0-6.708-7.218Z"></path></svg>
                    <svg aria-label="Comentar" className="fill-tertiary-700 dark:fill-gray-300 text-tertiary-700 dark:text-gray-300" height="24" role="img" viewBox="0 0 24 24" width="24"><title>Comentar</title><path d="M20.656 17.008a9.993 9.993 0 1 0-3.59 3.615L22 22Z" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2"></path></svg>
                    <svg aria-label="Compartir publicación" className="fill-tertiary-700 dark:fill-gray-300 text-tertiary-700 dark:text-gray-300 mt-1" height="24" role="img" viewBox="0 0 24 24" width="24"><title>Compartir publicación</title><line fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2" x1="22" x2="9.218" y1="3" y2="10.083"></line><polygon fill="none" points="11.698 20.334 22 3.001 2 3.001 9.218 10.084 11.698 20.334" stroke="currentColor" strokeLinejoin="round" strokeWidth="2"></polygon></svg>
                </div>
                <div className="flex">
                    <svg aria-label="Guardar" className="fill-tertiary-700 dark:fill-gray-300 text-tertiary-700 dark:text-gray-300" height="24" role="img" viewBox="0 0 24 24" width="24"><title>Guardar</title><polygon fill="none" points="20 21 12 13.44 4 21 4 3 20 3 20 21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></polygon></svg>
                </div>
            </div>
            <div className="px-4 flex items-center py-3 pb-2 gap-1">
                <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="h-4 w-4 rounded-full" />
                <span className="!text-sm text-tertiary-700 dark:text-gray-100">&nbsp;Liked by <b>{user_name || integration?.name || company?.name}</b> {like_count > 0 && <> and <b>{formatNumber(like_count, 0)} others</b></>}</span>
            </div>
            <div className="px-4 pb-4">
                <TextPreview 
                    text={text} 
                    network={network} 
                    isEditable={isEditable && !isSimpleView} // Update this line
                    post={post}
                    onTextEdit={(value) => onTextEdit(postIndex, value)}
                />
            </div>
            <CommentSection 
                post={post}
                network={network}
                integration={integration}
                company={company}
            />
        </div>
    )
}

export default InstagramFeedPreview;